export default __webpack_public_path__ + "static/media/cubes.f03127de.png";